module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('form', {
    staticClass: "bs-example form-horizontal form-grv"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Dados para Retirada / Pagamento\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("820000600 - KVX4650")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Data prevista para retirada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("22/11/2019")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                      Dados do Pagador\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Luiz Thomaz Fernandes")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tipo do documento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    staticClass: "form-control"
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("CPF")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Documento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("058.511.307-68")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                      Endereço Pagador\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("27253003")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Rodovia dos Metalúrgicos")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("480")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Casa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("São Geraldo")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Volta Redonda")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Rio de Janeiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    staticClass: "control-label text-left"
  }, [_vm._v("Estado")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                      Cobrancas\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("valor")]), _vm._v(" "), _c('th', [_vm._v("Desconto")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Atalho")]), _vm._v(" "), _c('th', [_vm._v("Detalhes")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Diárias e Reboque para GRV 820000600")]), _vm._v(" "), _c('td', [_vm._v("Normal")]), _vm._v(" "), _c('td', [_vm._v("18/11/2019")]), _vm._v(" "), _c('td', [_vm._v("Diárias e Reboque para GRV 820000600")]), _vm._v(" "), _c('td', [_vm._v("1238,98")]), _vm._v(" "), _c('td', [_vm._v("(Nenhum)")]), _vm._v(" "), _c('td', [_vm._v("PAGO")]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "text-info"
  }, [_vm._v("\n                          Ver Boleto\n                        ")])]), _vm._v(" "), _c('td', [_c('router-link', {
    staticClass: "text-info",
    attrs: {
      "to": {
        name: 'cobranca.visualizar'
      }
    }
  }, [_vm._v("Detalhes")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar e adicionar outro(a)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar e continuar editando")])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6041e599","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/preretirada/components/Retirada.vue
// module id = 1706
// module chunks = 17